// Pure reorder logic shared by the modules and lessons tables. Kept free of any
// DOM / dnd-kit imports so it is trivially unit-testable.

function move<T>(arr: T[], from: number, to: number): T[] {
  const next = arr.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}

/**
 * Move the item with `activeId` to the position of `overId`, then renumber every
 * item's `sortOrder` to match its new index. Ids are compared as strings because
 * dnd-kit surfaces row ids (from antd `data-row-key`) as strings.
 * Returns the original array reference when either id is missing (no-op).
 */
export function reorderByDrag<T extends { id: number; sortOrder: number }>(
  items: T[],
  activeId: string,
  overId: string,
): T[] {
  const from = items.findIndex((i) => String(i.id) === activeId);
  const to = items.findIndex((i) => String(i.id) === overId);
  if (from === -1 || to === -1) return items;
  return move(items, from, to).map((item, index) => ({ ...item, sortOrder: index }));
}
